module.exports = __webpack_public_path__ + "static/img/newsk.10aa9c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsk.png
// module id = NRIi
// module chunks = 45